import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Row, Col } from 'reactstrap';
import PageTitle from 'components/PageTitle';
import Layout from 'components/Layout';
import CategoriesList from 'components/Categories';
import { ProductsListCompare } from 'components/ProductsList';
import CompareContainer from 'components/CompareContainer';
import Paginate from 'components/Paginate';
import Filters from 'components/Filters';
import ThreeBounce from 'components/ThreeBounce';
import { fetchProducts } from 'actions/products';
import { addQuery, removeQuery } from 'lib/query-params';
import i18n from 'i18n';
import { fetchUsages } from 'actions/categories';
import { fetchBrand } from 'actions/brands';
import { fetchRetailers } from 'actions/retailers';
import { PAGE_SIZE, PRODUCTS_SORT_OPTIONS } from '../constants';

class Search extends Component {
  static async getInitialProps({
    store,
    req,
    lang,
    query: { q, page = 1, retailer_id, sort_by, ...other }
  }) {
    store.dispatch(
      fetchUsages({ 'usages[q]': q, flat: 1, per_page: 10, ...other })
    );
    store.dispatch(fetchRetailers());
    if (other.brand_id) {
      store.dispatch(fetchBrand({ brand_id: other.brand_id }));
    }
    const params = { page, retailer_id, per_page: PAGE_SIZE, ...other };
    if (PRODUCTS_SORT_OPTIONS[sort_by]) {
      // Without an explicit sort option results are ordered by search rank (API's default)
      params.sort = PRODUCTS_SORT_OPTIONS[sort_by];
    }
    params.q = q;
    return store.dispatch(fetchProducts(params));
  }

  render() {
    const {
      products: { items, total, comparisons, loading },
      usages: children,
      brands,
      retailers,
      ...rest
    } = this.props;
    const { page, retailer_id, sort_by, q, brand_id } = this.props.url.query;
    const brand = brands[brand_id];
    const keyword = brand_id ? brand.name + ' ' + (q || '') : q;
    const meta = {
      title: `${i18n.t('SEARCH_RESULTS_FOR')} ${keyword}`
    };
    const noResults = parseInt(total) === 0;
    return (
      <Layout {...rest} dept="product-checker" meta={meta}>
        <div className="container">
          <PageTitle center>{meta.title}</PageTitle>
          <CompareContainer comparisons={comparisons} dispatch={rest.dispatch}>
            <Row>
              <Col xs={12} sm={12} md={4} lg={3}>
                <SidebarHeading first>{i18n.t('CATEGORIES')}</SidebarHeading>
                <CategoriesList.Sub category={{ children }} />
              </Col>
              <Col xs={12} sm={12} md={8} lg={9} className="px-sm-3 px-0">
                <div className="d-flex px-sm-0 pl-2">
                  <Filters.Retailers
                    options={retailers.items}
                    selected={retailer_id}
                    onSelect={onRetailerSelect}
                  />
                  <div className="ml-2 ml-sm-3" />
                  <Filters.Sort
                    options={[
                      'best_match',
                      'most_sustainable',
                      'most_healthy',
                      'least_healthy'
                    ]}
                    selected={sort_by || 'best_match'}
                    onSelect={onFilterChange}
                  />
                </div>
                {noResults && (
                  <em className="text-muted">{i18n.t('NO_SEARCH_RESULTS')}</em>
                )}
                <ProductsListCompare
                  items={items}
                  comparisons={comparisons}
                  dispatch={rest.dispatch}
                />
                {loading && <ThreeBounce className="w-100 mx-auto py-5" />}
                <div className="my-5 d-flex justify-content-center">
                  <Paginate current={parseInt(page || 1)} total={total} />
                </div>
              </Col>
            </Row>
          </CompareContainer>
        </div>
      </Layout>
    );
  }
}

Search.propTypes = {
  products: PropTypes.object,
  usages: PropTypes.array,
  brands: PropTypes.object,
  retailers: PropTypes.object,
  url: PropTypes.object
};

export default connect(({ products, categories, brands, retailers }) => ({
  products,
  usages: categories.usages,
  brands: brands.selected,
  retailers
}))(Search);

function onRetailerSelect(item) {
  if (!item.id) return removeQuery('retailer_id', 'page');
  addQuery({ retailer_id: item.id, page: 1 });
}

function onFilterChange(item) {
  addQuery({ sort_by: item.id, page: 1 });
}

export const SidebarHeading = styled.h6`
  font-weight: 400;
  color: #666;
  margin-top: ${(props) => (props.first ? 15 : 30)}px;
  margin-bottom: 15px;
  background: #f8f8f8;
  padding: 10px;
  border-radius: 4px;
`;
